/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "../../utils/bindUrl";
import {
  IPricingPlan,
  IResponseListPricingPlans,
  IResponseShowPricingPlan,
} from "../../interfaces/pricingPlans";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/pricing_plans";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listPricingPlans({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListPricingPlans>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showPricingPlan({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowPricingPlan>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createPricingPlan({
  pricingPlan,
}: {
  pricingPlan: IPricingPlan;
}) {
  const { data } = await api.post<IResponseShowPricingPlan>(BASE, {
    pricingPlan,
  });
  return data;
}

export async function updatePricingPlan({
  id,
  pricingPlan,
}: {
  id: string | number;
  pricingPlan: IPricingPlan;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowPricingPlan>(url, {
    pricingPlan,
  });
  return data;
}

export async function deletePricingPlan({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  // validateStatus => true evita cair no interceptor de erro (toast automático)
  const resp = await api.delete(url, { validateStatus: () => true });
  return { status: resp.status, data: resp.data };
}
